export default {"src":"/_next/static/media/image-2-mob.d69b382a.svg","height":140,"width":254,"blurWidth":0,"blurHeight":0};